import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blocks } from '../data/newsData';
import './BlocksListing.css';

function BlocksListing() {
  const [selectedBlock, setSelectedBlock] = useState(null);

  const handleBlockClick = (block) => {
    setSelectedBlock(block);
  };

  const selectedBlockData = selectedBlock ? blocks.find(b => b.id === selectedBlock) : null;

  return (
    <div className="blocks-page">
      {/* Header */}
      <section className="blocks-header">
        <div className="container">
          <h1>🏛️ चित्रकूट के ब्लॉक्स और गाँव</h1>
          <p>स्थानीय क्षेत्रों के बारे में विस्तृत जानकारी</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="blocks-content">
        <div className="container">
          <div className="blocks-layout">
            {/* Blocks List */}
              <h2>सभी ब्लॉक्स</h2>
            <div className="blocks-list">
              <div className="blocks-grid">
                {blocks.map(block => (
                  <div
                    key={block.id}
                    className={`block-card ${selectedBlock === block.id ? 'active' : ''}`}
                    onClick={() => handleBlockClick(block.id)}
                  >
                    <div className="block-card-icon">{block.icon}</div>
                    <h3>{block.name}</h3>
                    <p>{block.description}</p>
                    <div className="block-meta">
                      <span>📍 {block.area}</span>
                      <span>👥 {block.population}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Villages List */}
            <div className="villages-section">
              {selectedBlockData ? (
                <>
                  <div className="block-hero">
                    <img src={selectedBlockData.image} alt={selectedBlockData.name} />
                    <div className="block-hero-content">
                      <h2>{selectedBlockData.name}</h2>
                      <p>{selectedBlockData.description}</p>
                    </div>
                  </div>

                  <div className="villages-grid">
                    <h3>गाँव ({selectedBlockData.villages.length})</h3>
                    <div className="villages-list">
                      {selectedBlockData.villages.map(village => (
                        <Link
                          key={village.id}
                          to={`/village/${village.id}`}
                          className="village-card"
                        >
                          <img src={village.image} alt={village.name} />
                          <div className="village-content">
                            <h4>{village.name}</h4>
                            <p>{village.description}</p>
                            <div className="village-stats">
                              <span>👥 {village.population}</span>
                              <span>📍 {village.area}</span>
                            </div>
                            <button className="detail-btn">विस्तृत जानकारी</button>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <div className="no-selection">
                  <div className="placeholder-icon">👈</div>
                  <p>किसी भी ब्लॉक को चुनें और गाँवों की जानकारी देखें</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlocksListing;
